var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_7402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.625 26.25V13.125C50.625 12.6277 50.4275 12.1508 50.0758 11.7992C49.7242 11.4475 49.2473 11.25 48.75 11.25H11.25C10.7527 11.25 10.2758 11.4475 9.92418 11.7992C9.57254 12.1508 9.375 12.6277 9.375 13.125V26.25C9.375 48.75 30 54.375 30 54.375C30 54.375 50.625 48.75 50.625 26.25Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.8945,
    y: 28.2257,
    width: 17.5947,
    height: 11.4357,
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4131 23.8591C25.4131 20.9437 27.7765 18.5803 30.6919 18.5803V18.5803C33.6073 18.5803 35.9707 20.9437 35.9707 23.8591V28.2257H25.4131V23.8591Z",
    stroke: "white",
    strokeWidth: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_7402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccess);
export default __webpack_public_path__ + "static/media/access.6455ce5d95e31457cd9c2c67c8888191.svg";
export { ForwardRef as ReactComponent };